import { render, staticRenderFns } from "./Newsong.vue?vue&type=template&id=deb7c304&scoped=true&"
import script from "./Newsong.vue?vue&type=script&lang=js&"
export * from "./Newsong.vue?vue&type=script&lang=js&"
import style0 from "./Newsong.vue?vue&type=style&index=0&id=deb7c304&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb7c304",
  null
  
)

export default component.exports